import { useState, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import './BurgerMenu.css'

export default function BurgerMenu() {
    const [open, setOpen] = useState(false)
    const menuRef = useRef(null)
    const navigate = useNavigate()

    useEffect(() => {
        function handleClickOutside(e) {
            if (menuRef.current && !menuRef.current.contains(e.target)) {
                setOpen(false)
            }
        }

        if (open) {
            document.addEventListener('mousedown', handleClickOutside)
            document.addEventListener('touchstart', handleClickOutside)
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
            document.removeEventListener('touchstart', handleClickOutside)
        }
    }, [open])

    const goTo = (path) => {
        navigate(path)
        setOpen(false)
    }

    return (
        <div className="burger-wrapper" ref={menuRef}>
            <button
                className="burger"
                onClick={() => setOpen((prev) => !prev)}
                aria-label="Открыть меню"
            >
                ☰
            </button>

            {open && (
                <div className="burger-menu">
                    <div className="menu-item" onClick={() => goTo('/database')}>
                        База данных
                    </div>
                    <div className="menu-item" onClick={() => goTo('/main')}>
                        Просмотр расписания
                    </div>
                    <div className="menu-item" onClick={() => goTo('/editor')}>
                        Редактор расписания
                    </div>
                    <div className="menu-item" onClick={() => goTo('/history')}>
                        История изменений
                    </div>
                    <div className="menu-item" onClick={() => goTo('/education')}>
                        Обучение
                    </div>
                    <div className="menu-item" onClick={() => goTo('/about')}>
                        О разработчиках
                    </div>
                </div>
            )}
        </div>
    )
}